import React from "react";
import {
  Map,
  Placemark,
  YMaps,
  TypeSelector,
  GeolocationControl,
  FullscreenControl,
  RouteButton,
  SearchControl,
  TrafficControl,
  ZoomControl,
} from "react-yandex-maps";
export const Maps = () => {
  return (
    <div>
      <YMaps>
        <Map
          style={{ width: "100%", height: "100vh" }}
          defaultState={{
            center: [126.830, 126.830],
            zoom: 10,
            controls: [],
          }}
        >
          {/* <Placemark geometry={[126.130, 126.730]} />
          <Placemark geometry={[126.230, 126.830]} />
          <Placemark geometry={[126.630, 126.630]} />
          <Placemark geometry={[126.730, 126.530]} />
          <Placemark geometry={[126.830, 126.430]} /> */}


          <TypeSelector options={{ float: "right" }} />
          <GeolocationControl options={{ float: "left" }} />
          <FullscreenControl />
          <RouteButton options={{ float: "right" }} />
          <SearchControl options={{ float: "right" }} />
          <TrafficControl options={{ float: "right" }} />
          <ZoomControl options={{ float: "right" }} />
        </Map>
      </YMaps>
    </div>
  );
};
export default Maps;
